import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OnCallFilterSelectionChangedEvent } from '@pages/on-call-page/interfaces';

@Injectable({ providedIn: 'root' })
export class OnCallFilteredItemsService {
  onCallGridFilterChanged$: BehaviorSubject<OnCallFilterSelectionChangedEvent> =
    new BehaviorSubject<OnCallFilterSelectionChangedEvent>({ items: [] });
}
